<template>
  <div class="affiliation">
    <v-btn
      color="#0498af"
      tile
      depressed
      class="white--text rounded-lg"
      x-large
      height="48px"
      @click="goToAffiliation"
      v-if="!isProvider"
    >
      Afiliarme ahora
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'FooterAffiliation',
  computed: {
    isProvider() {
      return this.$auth.check() && this.$auth.user().provider;
    },
  },
  methods: {
    goToAffiliation() {
      if (this.$auth.check()) {
        const user = this.$auth.user();
        if (user.provider) {
          this.$router.push({
            name: 'providersite',
            params: {
              slug: user.provider.slug,
            },
          });
        } else {
          this.$router.push({
            name: 'affiliation',
          });
        }
      } else {
        this.$router.push({
          name: 'affiliation',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.affiliation {
  max-width: 380px;

  a {
    color:#fff!important;
    text-decoration: underline!important;
  }
}
</style>
